import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, exhaustMap, map, of } from "rxjs";
import { ApuStandardCategoryTypeActions } from "./apu-standard-category-type.actions";
import { ApuStandardService } from "@/core/services/apu-standard.service";
import { ApuStandardApiModel } from "@/core/models/api/apu-standard-api.model";
import { ApuStandardCategoryTypeService } from "@/core/services/apu-standard-category-type.service";
import { ApuStandardCategoryTypeApiModel } from "@/core/models/api/apu-standard-category-type-api.model";

@Injectable()
export class ApuStandardCategoryTypeEffects {
    actions$ = inject(Actions);
    apuStandardCategoryType = inject(ApuStandardCategoryTypeService);

    constructor(){

    }

    _loadApuStandardCategoryType = createEffect(() => {
        return this.actions$.pipe(
            ofType(ApuStandardCategoryTypeActions.loadApuStandardCategoryTypes),
            exhaustMap(() => {
                return this.apuStandardCategoryType.getAll().pipe(
                    map((response: any) => {
                        const apuStandardCategoryTypes = response as ApuStandardCategoryTypeApiModel[];
                        return ApuStandardCategoryTypeActions.loadApuStandardCategoryTypeSuccess({ apuStandardCategoryTypes });
                    }),
                    catchError((error) => {
                        console.error(error);
                        return of();
                    })
                )
            })
        )
    })

    _addRange = createEffect(() => {
        return this.actions$.pipe(
            ofType(ApuStandardCategoryTypeActions.addRangeApuStandardCategoryTypes),
            exhaustMap((action) => {
                return this.apuStandardCategoryType.addRange(action.apuStandardCategoryTypes).pipe(
                    map((response: any) => {
                        const apuStandardCategoryType = response as ApuStandardCategoryTypeApiModel;
                        return ApuStandardCategoryTypeActions.addRangeApuStandardCategoryTypeSuccess({ apuStandardCategoryType });
                    }),
                    catchError((error) => {
                        console.error(error);
                        return of();
                    })
                )
            })
        )
    })

    _deleteProjectType = createEffect(() => {
        return this.actions$.pipe(
            ofType(ApuStandardCategoryTypeActions.deleteApuStandardCategoryType),
            exhaustMap((action) => {
                return this.apuStandardCategoryType.delete(action.apuStandardCategoryTypeId).pipe(
                    map((response: any) => {
                        console.log('RESPONSE: ', response);
                        return ApuStandardCategoryTypeActions.deleteApuStandardCategoryTypeSuccess({ apuStandardCategoryTypeId: action.apuStandardCategoryTypeId });
                    }),
                    catchError((error) => {
                        console.error(error);
                        return of();
                    })
                )
            })
        )
    })
}